<template>
  <div>
   <h1>A <v-icon>{{items[picked]}}</v-icon> B</h1>
    <br>
    <v-btn-toggle v-model="picked" mandatory>
      
      <v-btn text>
        <v-icon>{{items[0]}}</v-icon>
      </v-btn>
      <v-btn text>
        <v-icon>{{items[1]}}</v-icon>
      </v-btn>
      <v-btn text>
        <v-icon>{{items[2]}}</v-icon>
      </v-btn>
      <v-btn text>
        <v-icon>{{items[3]}}</v-icon>
      </v-btn>
      <v-btn text>
        <v-icon>{{items[4]}}</v-icon>
      </v-btn>
      <v-btn text>
        <v-icon>{{items[5]}}</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
<script>
export default {
  props: ["emitter", "ikey", "getData", "putData"],
  data() {
    return {
      picked: 0,
      items:
      [
        'fas fa-greater-than-equal',
        'fas fa-greater-than',
        'fas fa-equals',
        'fas fa-not-equal',
        'fas fa-less-than',
        'fas fa-less-than-equal'
      ]
    };
  },
  methods: {
    update(newVal, oldVal) {
      if (this.ikey) {
        this.putData(this.ikey, this.picked);
      }
      if (this.emitter !== undefined) this.emitter.trigger("process");
    }
  },
  watch: {
    picked: function(newVal, oldVal) {
      this.update(newVal, oldVal);
    }
  },
  mounted() {
    if (this.getData !== undefined) {
      this.picked = this.getData(this.ikey);
    }
  }
};
</script>

<style>
</style>
